<div class="col-12" *ngIf="false">
  <app-busy></app-busy>
</div>

<div class="container-fluid">
  <ul class="nav nav-tabs" style="display: table; width: 100%">
    <li class="nav-item col-md-4" style="display: table-cell">
      <a
        (click)="selectedTab = 0"
        style="text-align: center"
        class="nav-link active"
        aria-current="page"
        aria-controls="one"
        role="tab"
        data-toggle="tab"
        >All</a
      >
    </li>
    <li class="nav-item col-md-4" style="display: table-cell">
      <a
        (click)="selectedTab = 1"
        class="nav-link"
        style="text-align: center"
        role="tab"
        data-toggle="tab"
        >Due (1 month)</a
      >
    </li>
    <li class="nav-item col-md-4" style="display: table-cell">
      <a
        (click)="selectedTab = 2"
        class="nav-link"
        style="text-align: center"
        role="tab"
        data-toggle="tab"
        >Overdue</a
      >
    </li>
  </ul>

  <div class="tab-content">
    <div
      *ngIf="selectedTab === 0"
      role="tabpanel"
      class="tab-pane active"
      id="one"
    >
      <div class="row">
        <div style="margin-top: 30px">
          <h4>
            <span style="padding-right: 15px"></span> <i class="fa fa-cogs"></i
            ><b> Annual Compliance Certificates</b>
          </h4>
        </div>
      </div>
      <hr />
      <div *ngIf="!compliancelist">
        <h6>you have no permits that have annual compliance.</h6>
      </div>
      <div class="col-lg-12">
        <div *ngIf="compliancelist">
          <div
            *ngFor="let carr of compliancelist; let i = index"
            style="bottom: solid 1px black; margin-top: 15x"
            id="accordion"
            data-toggle="carr.collapse"
            attr.data-target="#collapse_ + i"
            aria-expanded="false"
            aria-label="Toggle navigation"
            [attr.aria-expanded]="!collapse"
            aria-controls="collapse_ + i"
          >
            <div (click)="carr.collapse = !carr.collapse" class="row mainMenu">
              <span
                class="navbar-toggler col-lg-4"
                type="button"
                style="color: #274798; margin-top: 5px; font-size: 16px"
              >
                <i class="navbar-toggler-icon"></i
                ><i
                  class="fa fa-caret-right"
                  style="margin-right: 5px"
                  *ngIf="carr.collapse"
                ></i>
                <i
                  class="fa fa-caret-down"
                  style="margin-right: 5px"
                  *ngIf="!carr.collapse"
                ></i>
                Account Number: {{ carr.account_number }}
              </span>

              <div class="col-lg-4" style="margin-top: 10px">
                <span class="accountName">{{ carr.account_name }}</span>
              </div>
              <div class="col-lg-4" style="margin-top: 10px">
                <span class="records"
                  >records: {{ carr.compliance_records?.length }}</span
                >
              </div>
            </div>
            <div
              style="justify-content: center"
              id="collapse_ + i"
              [ngbCollapse]="carr.collapse"
              data-parent="#accordion"
              *ngIf="carr.compliance_records?.length > 0"
            >
              <div
                *ngFor="let comp of carr.compliance_records; let j = index"
                id="#accordian2"
                style="width: 98%"
              >
                <div
                  class="row mainCoreMenu"
                  style="background: #cfcfcf"
                  data-toggle="comp.isCollapsed"
                  attr.data-target="#collapsec_ + j"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  (click)="comp.isCollapsed = !comp.isCollapsed"
                  aria-controls="collapsec_ + j"
                >
                  <span
                    class="navbar-toggler col-lg-4"
                    style="color: #274798; margin-top: 5px; font-size: 14px"
                  >
                    <span class="navbar-toggler-icon"></span
                    ><i
                      class="fa fa-chevron-right"
                      *ngIf="comp.isCollapsed"
                    ></i>
                    <i class="fa fa-chevron-down" *ngIf="!comp.isCollapsed"></i>
                    Permit:{{ comp.permit_num }}
                  </span>
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4">
                    <span class="recordsDate"
                      >Compliance due date:
                      {{ comp.compliant_duedate | date : "dd/MM/yyyy" }}</span
                    >
                  </div>
                </div>
                <div
                  class="list-group collapse"
                  id="collapsec_ +j"
                  [ngbCollapse]="comp.isCollapsed"
                  data-parent="#accordian2"
                >
                  <div class="row">
                    <div
                      title="permit type description"
                      class="col-lg-3 divHeader"
                    >
                      Compliance Num
                    </div>
                    <div
                      rowspan="2"
                      title="permit type description"
                      class="col-lg-3 divHeader"
                    >
                      Permit Type
                    </div>
                    <div
                      rowspan="1"
                      title="permit type description"
                      class="col-lg-3 divHeader"
                    >
                      Route
                    </div>

                    <div
                      rowspan="2"
                      title="permit type description"
                      class="col-lg-3 divHeader"
                    >
                      Vehicle
                    </div>
                    <!--                                  
                                  <div rowspan="2" title="permit type description" style="text-align: center !important;" >Action 
                                </div> -->
                  </div>

                  <div class="row">
                    <div
                      style="text-align: center !important"
                      class="col-lg-3 divDisplay"
                    >
                      {{ comp.id }}
                    </div>
                    <div
                      style="text-align: center !important"
                      class="col-lg-3 divDisplay"
                    >
                      {{ comp.permit_type }}
                    </div>
                    <div
                      style="
                        text-align: center !;
                        display: inline-flex;
                        overflow: hidden;
                      "
                      class="col-lg-3 divDisplay"
                    >
                      {{ comp.route }}
                    </div>
                    <div
                      style="text-align: center !important"
                      class="col-lg-3 divDisplay"
                    >
                      {{ comp.VN_num }}
                    </div>

                    <div style="text-align: center !important">
                      <!-- <div style="display: inline-block;padding-left: 5%;"><button (click)="showDetails(comp)" class="navigateBtn">Apply</button></div> -->
                    </div>
                  </div>
                  <div style="text-align: -webkit-center">
                    <div style="max-width: 75%" id="accordian3">
                      <div
                        class="row"
                        style="
                          border: solid 2px #274798;
                          border-radius: 12cm;
                          background: #cfcfcf;
                        "
                        *ngIf="comp.compliance_permits_details"
                      >
                        <div
                          title="permit type description"
                          class="col-lg-3 divHeader"
                        >
                          Detail ID
                        </div>
                        <div
                          rowspan="2"
                          title="permit type description"
                          class="col-lg-3 divHeader"
                        >
                          Compliance Year
                        </div>
                        <div
                          rowspan="1"
                          title="permit type description"
                          class="col-lg-3 divHeader"
                        >
                          Compliance Status
                        </div>
                        <div
                          rowspan="2"
                          title="permit type description"
                          class="col-lg-3 divHeader"
                        >
                          Submission Date
                        </div>
                        <!-- <div rowspan="2" title="permit type description" style="text-align: center !important;" >Action 
                                      </div>  -->
                      </div>
                      <!-- <div style="background:  #e7dddd;">              
                                      <button style="margin-left: 15px;" class="navbar-toggler btn btn-outline-primary" type="button" data-toggle="item.isCollapsedt" attr.data-target="#collapse_r + t"   aria-expanded="false" aria-label="Toggle navigation" (click)="item.isCollapsedt = !item.isCollapsedt"  aria-controls="collapse_r + t" >
                                        <span class="navbar-toggler-icon"></span><i class="fa fa-chevron-circle-right"   *ngIf="item.isCollapsedt"></i>   
                                        <i class="fa fa-chevron-circle-down" style="size: 6px;" *ngIf="!item.isCollapsedt"></i>Compliance record:{{ item.submission_date }} 
                                      </button>
                                    </div> -->
                      <div style="max-width: 97%">
                        <div
                          class="row"
                          *ngFor="
                            let item of comp.compliance_permits_details;
                            let t = index
                          "
                          style="border: solid 0.5px"
                        >
                          <div
                            style="text-align: center !important"
                            class="col-lg-3 divDisplay"
                          >
                            {{ item.id }}
                          </div>
                          <div
                            style="text-align: center !important"
                            class="col-lg-3 divDisplay"
                          >
                            {{ item.compliance_year }}
                          </div>
                          <div
                            style="text-align: center !important"
                            class="col-lg-3 divDisplay"
                          >
                            {{ item.compliance_status }}
                          </div>
                          <div
                            style="text-align: center !important"
                            class="col-lg-3 divDisplay"
                          >
                            {{ item.submission_date | date : "dd/MM/yyyy" }}
                          </div>
                          <div style="text-align: center !important">
                            <!-- <div style="display: inline-block;padding-left: 5%;"><button (click)="showDetails(item)" class="navigateBtn">Apply</button></div>
                                          </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="selectedTab === 1"
        role="tabpanel"
        class="tab-pane active"
        id="two"
      >
        wallet 2 content
      </div>
      <div
        *ngIf="selectedTab === 2"
        role="tabpanel"
        class="tab-pane active"
        id="two"
      >
        wallet 3 content
      </div>
    </div>
  </div>

  <!--   <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h4><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Compliance Reports</b>
      </h4>
    </div>
  </div>
  <hr>
  <fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;">
    <legend class="scheduler-border tsk-display blackcontrol">Filters</legend>
    <table style="width: calc(100% - 40px); margin-left: 20px; margin-bottom: 15px;">
      <tr>
        <td style="padding-right: 50px;">
          <label><b>Month:</b></label>
          <select #month class="form-control form-control-sm show-h" (click)="selectMonth(month.value)">
            <option *ngFor="let calendar of calendarList" [selected]="checkThisMonth(calendar)" [value]="calendar.id">
              {{calendar.mmm}} {{calendar.dd}} {{calendar.yyyy}}</option>
          </select>
        </td>
        <td style="padding-right: 50px;">
          <label><b>Carrier:</b></label>
          <select class="form-control form-control-sm show-h">
            <option [value]="0">All</option>
            <option *ngFor="let carrier of carrierListFilter" [value]="carrier.CarrierId">{{carrier.CarrierName}}
            </option>
          </select>
        </td>
        <td style="padding-right: 50px;">
          <label><b>Compliant/Non Compliant:</b></label>
          <select class="form-control form-control-sm show-h">
            <option [value]="1">Both</option>
            <option [value]="2">Compliant-only</option>
            <option [value]="3">Non-Compliant only</option>
          </select>
        </td>
        <td>
          <span (click)="onReset()" title="Reset filters..." class="btn btn-success pull-right"><i class="fa fa-undo"
              aria-hidden="true"></i></span>
          <span title="Apply filters..." (click)="selectMonth(month.value)" class="btn btn-primary pull-right"
            style="margin-right:4px!important;"><i class="fa fa-search" aria-hidden="true"></i></span>
        </td>
      </tr>
    </table>
  </fieldset>
  <br>

  <div class="row">
    <div class="col-md-12">

      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Code <i
                style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"></i>
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Carrier Name <i
                style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"></i>
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Long Term or Temp <i
                style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"></i>
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Freight or Pax <i
                style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"></i>
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Num Permits <i
                style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"></i>
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Num Returns Submitted
              <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"></i>
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Compliance Status <i
                style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"></i>
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Compliance (previous
              6 months) <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <table style="width: 100%;">
                <tr>
                  <td *ngFor="let month of lastSixMonths" align="center">{{month.mmm}} {{month.dd}}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr class="tbl-row" *ngFor="let item of carrierlist" (click)="clickCarrier(item)" style="cursor: pointer;" >
            <td align="center">{{item.carrier_code}}</td>
            <td align="center">{{item.name}}</td>
            <td align="center">{{item.temp_long_ind}}</td>
            <td align="center">{{item.freight_passanger_ind}}</td>
            <td align="center">{{item.numpermits}}</td>
            <td align="center">{{item.numpermits}}</td>
            <td align="center">{{item.status_ind}}</td>
            <td>
              <table style="width: 100%;">
                <tr>
                  <td align="center">N</td>
                  <td align="center">N</td>
                  <td align="center">Y</td>
                  <td align="center">N</td>
                  <td align="center">Y</td>
                  <td align="center">N</td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
        <tfoot style="padding:0px;margin:0px;">
          <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">
                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize"
                      (change)="onChange()">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)"
                    style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No carrier compliance found.</span>
            </td>
          </tr>
        </tfoot>
      </table>


    </div>

  </div>
  <div>
    <div class="card-data">
      <div class="col-md-12">
        <button title="Back" type="button" id="btnBack" class="btn btn-md btn-primary pull-right"
          style="margin-left:10px; ">Back</button>
      </div>
    </div>
  </div>
</div> -->
</div>
